import React from "react";
import {
  ApprovalType,
  ApprovalTypeLabels,
} from "@/models/leave-requests.model";
import { StatusColors } from "@/utils/status-colours";

interface Props {
  status: ApprovalType;
}

function ApprovalTypeTag({ status }: Props) {
  const colors = StatusColors[status];

  return (
    <div
      className={`${colors.bg} ${colors.text}
        flex pt-2 pb-2 pl-3 pr-3 rounded-xl font-semibold justify-center items-center w-max text-xs`}
    >
      {ApprovalTypeLabels[status]}
    </div>
  );
}

export default ApprovalTypeTag;
